// Spanish translations
export const esTranslations = {
  common: {
    // Hero section
    "hero.title": "Controla tus contratos",
    "hero.subtitle": "Simplifica la gestión de contratos con nuestra potente solución. Obtén una visión completa, reduce costos y nunca más te pierdas un vencimiento.",
    "hero.companyTitle": "Gestión de contratos simplificada",
    "hero.companySubtitle": "La versión básica de Subtrackr siempre es gratis",
    "hero.pricing": "",
    "hero.benefit1": "Obtenga control sobre todos sus contratos sin costo - Usted elige si necesita actualizar a un plan de pago",
    "hero.benefit2": "",
    "hero.getStarted": "Comenzar ahora",
    "hero.learnMore": "Más información",
    "hero.neverMiss": "Nunca te pierdas un vencimiento",

    // Features section
    "features.title": "Toma el control de tus contratos",
    "features.subtitle": "Nuestra plataforma proporciona todo lo que necesitas para gestionar contratos eficientemente",
    
    "features.contractManagement.title": "Gestión de contratos",
    "features.contractManagement.description": "Almacena y organiza todos tus contratos en un lugar seguro con búsqueda y filtrado fáciles",
    
    "features.reminders.title": "Recordatorios inteligentes",
    "features.reminders.description": "Recibe notificaciones oportunas sobre renovaciones y fechas límite de terminación para evitar renovaciones automáticas no deseadas",
    
    "features.dashboards.title": "Potentes paneles",
    "features.dashboards.description": "Obtén información con paneles visuales que muestran el estado del contrato, gastos y próximas renovaciones",
    
    "features.compliance.title": "Seguimiento de cumplimiento",
    "features.compliance.description": "Mantén un registro de los requisitos de cumplimiento y asegúrate de que tu negocio cumpla con las regulaciones",
    
    "features.notifications.title": "Notificaciones personalizadas",
    "features.notifications.description": "Configura programas de notificación para tu equipo basados en eventos y hitos contractuales",
    
    "features.collaboration.title": "Colaboración en equipo",
    "features.collaboration.description": "Comparte contratos con miembros del equipo y asigna roles y responsabilidades",

    // Testimonials section
    "testimonials.title": "De confianza para empresas en toda Noruega",
    "testimonials.subtitle": "Mira lo que nuestros clientes dicen sobre Subtrackr",
    
    "testimonials.quote1": "Subtrackr ha transformado la forma en que gestionamos los contratos. Hemos reducido los costos en un 15% al detectar renovaciones automáticas que habríamos perdido antes.",
    "testimonials.author1": "Maria Johansen",
    "testimonials.role1": "Directora de Operaciones",
    "testimonials.company1": "Nordic Solutions AS",
    
    "testimonials.quote2": "El panel nos da una visión completa de todos los contratos en todos los departamentos. Simple de usar e increíblemente efectivo.",
    "testimonials.author2": "Thomas Berg",
    "testimonials.role2": "CFO",
    "testimonials.company2": "Fjord Technology",
    
    "testimonials.quote3": "Hemos reducido el tiempo dedicado a la administración de contratos en un 70%. Solo los recordatorios valen la inversión.",
    "testimonials.author3": "Lisa Andersen",
    "testimonials.role3": "Asesora Legal",
    "testimonials.company3": "Greenscape Energy",
    
    // Pricing section
    "pricing.title": "Precios simples y transparentes",
    "pricing.subtitle": "Elige el plan que se adapte a tus necesidades",
    "pricing.perMonth": "/mes",
    "pricing.mostPopular": "Más popular",
    "pricing.question": "¿Necesitas una solución personalizada para tu empresa?",
    "pricing.contactUs": "Contáctanos",
    
    "pricing.starter.name": "Inicial",
    "pricing.starter.price": "999 NOK",
    "pricing.starter.description": "Perfecto para pequeñas empresas",
    "pricing.starter.feature1": "Hasta 50 contratos",
    "pricing.starter.feature2": "Notificaciones por email",
    "pricing.starter.feature3": "Informes básicos",
    "pricing.starter.feature4": "Soporte 24/7",
    "pricing.starter.button": "Comenzar ahora",
    
    "pricing.professional.name": "Profesional",
    "pricing.professional.price": "1.999 NOK",
    "pricing.professional.description": "Ideal para empresas en crecimiento",
    "pricing.professional.feature1": "Contratos ilimitados",
    "pricing.professional.feature2": "Paneles avanzados",
    "pricing.professional.feature3": "Colaboración en equipo",
    "pricing.professional.feature4": "Notificaciones personalizadas",
    "pricing.professional.feature5": "Soporte prioritario",
    "pricing.professional.button": "Comenzar prueba gratuita",
    
    "pricing.enterprise.name": "Empresarial",
    "pricing.enterprise.price": "3.999 NOK",
    "pricing.enterprise.description": "Para grandes organizaciones",
    "pricing.enterprise.feature1": "Todo ilimitado",
    "pricing.enterprise.feature2": "Integraciones personalizadas",
    "pricing.enterprise.feature3": "Gerente de cuenta dedicado",
    "pricing.enterprise.feature4": "Garantías SLA",
    "pricing.enterprise.feature5": "Funciones avanzadas de seguridad",
    "pricing.enterprise.feature6": "Opción en las instalaciones",
    "pricing.enterprise.button": "Contactar ventas",
    
    // CTA section
    "cta.title": "¿Listo para transformar tu gestión de contratos?",
    "cta.subtitle": "Únete a cientos de clientes satisfechos que han simplificado su gestión de contratos con Subtrackr",
    "cta.getStarted": "Comienza ahora",
    "cta.contactSales": "Contactar ventas",
    
    // Footer
    "footer.description": "Subtrackr ayuda a las empresas a tomar el control de sus contratos con potentes herramientas de gestión, recordatorios y análisis.",
    "footer.product": "Producto",
    "footer.features": "Características",
    "footer.pricing": "Precios",
    "footer.security": "Seguridad",
    "footer.company": "Empresa",
    "footer.about": "Acerca de",
    "footer.contact": "Contacto",
    "footer.privacy": "Política de privacidad",
    "footer.terms": "Términos de servicio",
    "footer.copyright": "© {{year}} Subtrackr. Todos los derechos reservados.",
    
    // Navigation
    "goToDashboard": "Ir al panel",
    "login": "Iniciar sesión",
    "signup": "Registrarse"
  },

  contractTypes: {
    subscription: {
      name: "Suscripción",
      description: "Un contrato recurrente con pagos regulares"
    },
    serviceAgreement: {
      name: "Acuerdo de Servicios",
      description: "Contrato para la prestación de servicios"
    },
    license: {
      name: "Acuerdo de Licencia",
      description: "Contrato para el uso de propiedad intelectual"
    },
    onetime: {
      name: "Compra Única",
      description: "Compra única sin renovación"
    },
    lease: {
      name: "Arrendamiento/Alquiler",
      description: "Contrato para alquiler de propiedades o equipos"
    },
    sales: {
      name: "Contrato de Venta",
      description: "Contrato para vender productos o servicios"
    },
    employment: {
      name: "Contrato Laboral",
      description: "Contrato con empleados"
    },
    intro: "Los tipos de contrato ayudan a categorizar sus acuerdos y aplicar reglas consistentes. Cada tipo puede tener configuraciones específicas de renovación y dirección/propósito.",
    empty: "Aún no tienes tipos de contrato. Agrega tipos predeterminados o crea los tuyos.",
    addingDefaults: "Agregando predeterminados...",
    addDefaults: "Agregar Tipos de Contrato Predeterminados",
    createManually: "Crear Tipo Manualmente",
    yourTypes: "Tus Tipos de Contrato",
    count: "Tienes {{count}} tipo(s) de contrato"
  },

  categories: {
    software: {
      name: "Software",
      description: "Licencias y suscripciones de software"
    },
    hardware: {
      name: "Hardware",
      description: "Hardware físico y equipamiento"
    },
    services: {
      name: "Servicios",
      description: "Servicios profesionales y de consultoría"
    },
    utilities: {
      name: "Servicios Públicos",
      description: "Servicios como electricidad, agua, etc."
    },
    rent: {
      name: "Alquiler",
      description: "Alquiler de oficinas y espacios de trabajo"
    },
    intro: "Las categorías te ayudan a organizar tus contratos y filtrarlos más efectivamente. Agrega algunas categorías que coincidan con las necesidades de tu organización.",
    noCategories: "Sin Categorías Aún",
    empty: "Aún no has creado ninguna categoría. Agrega algunas para ayudar a organizar tus contratos.",
    addDefaults: "Agregar Categorías Predeterminadas",
    createCustom: "Crear Categoría Personalizada"
  }
};
